<template>
    <FormSection title="Security Authentication">
        <template #content>
            <div class="row m-2">
                <div class="col-12">
                    <h6 class="mb-2 d-flex align-items-center">
                        <b class="me-2">Two-Factor Verification</b>
                    </h6>
                    <p class="field-title">
                        Enable this feature to add a second layer of security to user accounts. The user will be
                        required to enter a challenge code or provide a security key as another form of verification.
                    </p>
                    <div class="d-flex">
                        <div class="col-1">
                            <input
                                class="form-check-input mt-1 me-0"
                                v-model="securitySetup.IsEnabled"
                                :value="true"
                                type="radio"
                                id="enableTwoFATrue"
                            />
                            <label class="px-2" for="enableTwoFATrue">Enable</label>
                        </div>
                        <div class="col-1">
                            <input
                                class="form-check-input mt-1 me-0"
                                v-model="securitySetup.IsEnabled"
                                :value="false"
                                type="radio"
                                id="enableTwoFAFalse"
                            />
                            <label class="px-2" for="enableTwoFAFalse">Disable</label>
                        </div>
                    </div>
                </div>
                <div
                    :class="` ${v$.securitySetup.AllowedTypes.$error ? 'border border-danger rounded p-2' : ''} col-12 mt-3`"
                    v-if="securitySetup.IsEnabled"
                >
                    <p class="mb-1 d-flex align-items-center field-title">
                        Select to allow at least one of 2-Factor verification methods below for your organization.<span
                            class="text-danger"
                            >*</span
                        >
                    </p>
                    <div v-for="type of twoFATypes" :key="`${type.value}-${type.text}`">
                        <div class="pt-1 ps-1">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`type-${type.value}`"
                                :checked="securitySetup.AllowedTypes?.includes(type.value)"
                                @change="handletype(type.value)"
                            />
                            <label class="form-check-label" :for="`type-${type.value}`">
                                {{ type.text }}
                                <a
                                    tabindex="0"
                                    href="javascript:void(0);"
                                    role="button"
                                    class="ps-2"
                                    v-custom-popover="{ content: type.popover }"
                                >
                                    <i class="fas fa-info-circle text-primary font-size-xs"></i>
                                </a>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./SecurityAuthentication.ts"></script>
